/*
 * Copyright (c) Nexign, JSC, 2022-2023.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Ilya Babanov
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.19.0
 */

import { createApi } from '@reduxjs/toolkit/dist/query/react';

import { edmDeliveryTags, newsTags, pageAccountInfoTags, userNotificationsTags } from '@modules/app/apiTags';

import { baseQuery } from './baseQuery';

export const apiTags = [
    pageAccountInfoTags.ACCOUNT_INFO_DELIVERY_META,

    edmDeliveryTags.EDM_OPERATORS,

    // user notifications
    userNotificationsTags.USER_NOTIFICATIONS_SETTINGS,
    userNotificationsTags.USER_NOTIFICATIONS_LIST,

    // news
    newsTags.NEWS_LIST,
];

export const pageApi = createApi({
    reducerPath: 'pageApi',
    baseQuery,
    endpoints: () => ({}),
    tagTypes: apiTags,
});
